import { render, staticRenderFns } from "./patients.page.vue?vue&type=template&id=6899e3bf&"
import script from "./patients.page.vue?vue&type=script&lang=js&"
export * from "./patients.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports